export default __webpack_public_path__ + "static/media/EASYGO.c7271967.mp4";